<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Etkinlik Listesi">
          <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <span><strong>Not:</strong> Eklenecek etlinlik adı ve arama motoru
                bağlantı linki benzersiz olmalıdır...</span>
            </div>
          </b-alert>
          <b-button class="float-right" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
            :to="`/events/create`">
            Yeni Etkinlik Ekle
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Etkinlik Takvimi">
          <b-row>
            <b-col cols="1"> </b-col>
            <b-col cols="10">
              <div class="app-calendar overflow-hidden border">
                <div class="row no-gutters">
                  <!-- Sidebar -->
                  <div class="
                      col
                      app-calendar-sidebar
                      flex-grow-0
                      overflow-hidden
                      d-flex
                      flex-column
                    " :class="{ show: isCalendarOverlaySidebarActive }">
                    <calendar-sidebar :is-event-handler-sidebar-active.sync="
                      isEventHandlerSidebarActive
                    " />
                  </div>

                  <!-- Calendar -->
                  <div class="col position-relative">
                    <div class="card shadow-none border-0 mb-0 rounded-0">
                      <div class="card-body pb-0">
                        <full-calendar ref="refCalendar" :options="calendarOptions" class="full-calendar" />
                      </div>
                    </div>
                  </div>

                  <!-- Sidebar Overlay -->
                  <div class="body-content-overlay" :class="{ show: isCalendarOverlaySidebarActive }"
                    @click="isCalendarOverlaySidebarActive = false" />
                  <calendar-event-handler v-model="isEventHandlerSidebarActive" :event="event"
                    :clear-event-data="clearEventData" @remove-event="removeEvent" @add-event="addEvent"
                    @update-event="updateEvent" />
                </div>
              </div>
            </b-col>
            <b-col cols="1"> </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Etkinlikler">
          <b-form>
            <b-row>
              <b-col cols="12">
                <table class="table b-table table-responsive">
                  <thead>
                    <th>#</th>
                    <th>BAŞLIK</th>
                    <th>ETKİNLİK TİPİ</th>
                    <th>DURUM</th>
                    <th>TARİH</th>
                    <th>İŞLEMLER</th>
                  </thead>
                  <draggable v-model="events" class="cursor-move" tag="tbody" @change="outputData">
                    <tr v-for="event in events" :key="event.id">
                      <td>{{ event.id }}</td>
                      <td>{{ event.title }}</td>
                      <td>{{ event.eventType.name }}</td>
                      <td>
                        <b-badge v-if="event.isDraft == false" variant="light-success">
                          Yayında
                        </b-badge>
                        <b-badge v-if="event.isDraft == true" variant="light-warning">
                          Taslakta
                        </b-badge>
                      </td>
                      <td>{{ event.createdAt }}</td>
                      <td>
                        <b-button-group class="float-right">
                          <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-danger"
                            class="btn-icon rounded-circle" @click="deleteConfirmText(event.id)">
                            <feather-icon icon="TrashIcon" />
                          </b-button>
                        </b-button-group>
                        <b-button-group class="float-right mr-2">
                          <b-button v-for="language in languages" :key="language.locale"
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'" :variant="
                              event.languages.find(
                                (element) => element == language.locale
                              )
                                ? 'outline-warning'
                                : 'outline-secondary'
                            " :title="
  event.languages.find(
    (element) => element == language.locale
  )
    ? 'Düzenle'
    : 'Ekle'
" @click="action(event, language.locale)">
                            {{ language.locale.toUpperCase() }}
                          </b-button>
                        </b-button-group>
                      </td>
                    </tr>
                  </draggable>
                  <thead>
                    <th>#</th>
                    <th>BAŞLIK</th>
                    <th>ETKİNLİK TİPİ</th>
                    <th>DURUM</th>
                    <th>TARİH</th>
                    <th>İŞLEMLER</th>
                  </thead>
                </table>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Ripple from "vue-ripple-directive";
import draggable from "vuedraggable";
import {
  BRow,
  BCol,
  BImg,
  BCard,
  BForm,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BCardText,
  BButtonGroup,
  BListGroupItem,
  BButtonToolbar,
} from "bootstrap-vue";

import FullCalendar from "@fullcalendar/vue";
import store from "@/store";
import { onUnmounted } from "@vue/composition-api";
import calendarStoreModule from "./calendarStoreModule";
import CalendarSidebar from "./calendar-sidebar/CalendarSidebar.vue";
import CalendarEventHandler from "./calendar-event-handler/CalendarEventHandler.vue";
import useCalendar from "./useCalendar";

import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    BForm,
    BBadge,
    BAlert,
    BButton,
    BAvatar,
    BCardText,
    BButtonGroup,
    BListGroupItem,
    BButtonToolbar,
    draggable,
    FullCalendar, // make the <FullCalendar> tag available
    CalendarSidebar,
    CalendarEventHandler,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      events: [],
      request: [],
      languages: [],
    };
  },
  watch: {},
  methods: {
    action(node, locale) {
      let translationControl = node.languages.find(
        (element) => element == locale
      );
      if (translationControl == undefined) {
        this.$router.push({
          path: `/events/create/translation/${node.slug}?targetLocale=${locale}`,
        });
      } else {
        this.$router.push({
          path: `/events/edit/${node.slugs[locale]}?targetLocale=${locale}`,
        });
      }
    },
    outputData() {
      this.updateSubmit();
    },
    updateSubmit() {
      Object.entries(this.events).forEach(([key, value]) => {
        let eventsOrder = {
          slug: value.slug,
          order: parseInt(key),
        };
        this.request.push(eventsOrder);
      });
      endpoints
        .putEventsOrder({ events: this.request }, this.$i18n.locale, () => { })
        .then((data) => {
          this.$swal({
            icon: "success",
            title: "Güncelleme başarılı!",
            text: "Etkinlik sıralaması güncellendi.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getLanguages() {
      endpoints
        .getLanguages(null, this.$i18n.locale, () => { })
        .then((data) => {
          this.languages = [...data.response];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getEvents() {
      endpoints
        .getEvents(null, this.$i18n.locale, () => { })
        .then((data) => {
          this.events = [];
          this.events = [...data.response];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteConfirmText(id) {
      this.$swal({
        title: "Sil?",
        text: "Eğitmeni silmek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteSubmit(id);
        }
      });
    },
    deleteSubmit(id) {
      endpoints
        .deleteEvents(id, this.$i18n.locale, () => { })
        .then((data) => {
          this.getEvents();
          this.$swal({
            icon: "success",
            title: "Silme başarılı!",
            text: "Etkinlik silindi",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  setup() {
    const CALENDAR_APP_STORE_MODULE_NAME = "calendar";

    // Register module
    if (!store.hasModule(CALENDAR_APP_STORE_MODULE_NAME))
      store.registerModule(CALENDAR_APP_STORE_MODULE_NAME, calendarStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(CALENDAR_APP_STORE_MODULE_NAME))
        store.unregisterModule(CALENDAR_APP_STORE_MODULE_NAME);
    });

    const {
      refCalendar,
      isCalendarOverlaySidebarActive,
      event,
      clearEventData,
      addEvent,
      updateEvent,
      removeEvent,
      fetchEvents,
      refetchEvents,
      calendarOptions,

      // ----- UI ----- //
      isEventHandlerSidebarActive,
    } = useCalendar();

    fetchEvents();

    return {
      refCalendar,
      isCalendarOverlaySidebarActive,
      event,
      clearEventData,
      addEvent,
      updateEvent,
      removeEvent,
      refetchEvents,
      calendarOptions,

      // ----- UI ----- //
      isEventHandlerSidebarActive,
    };
  },
  mounted() {
    this.getLanguages();
    this.getEvents();
  },
};
</script>
<style>
.draggable-card {
  margin-bottom: 0;
}

.draggable-card>.card-body {
  padding: 10px;
}

.draggable-card>.card-body>.card-title {
  margin-bottom: 0;
  font-size: 1rem;
}

.tree-node {
  border: 0 !important;
}
</style>
<style lang="scss">
@import "@core/scss/vue/apps/calendar.scss";
</style>